import React from "react";
import MetricTooltip from "./MetricTooltip";

const MetricItem = ({
  icon: Icon,
  label,
  value,
  tooltip,
  isDarkMode,
  iconClassName,
  labelClassName,
}) => {
  return (
    <MetricTooltip
      isDarkMode={isDarkMode}
      content={tooltip}
      placement="top"
      maxWidthClass="max-w-sm"
    >
      <span className="flex items-center gap-2 cursor-help outline-none rounded">
        {Icon ? (
          <Icon size={12} className={iconClassName ?? (isDarkMode ? "text-gray-500" : "text-gray-400")} />
        ) : null}
        <span>
          <span className={`block text-[10px] ${labelClassName ?? (isDarkMode ? "text-gray-500" : "text-gray-400")}`}>
            {label}
          </span>
          <span className="block text-sm font-semibold">{value}</span>
        </span>
      </span>
    </MetricTooltip>
  );
};

export default MetricItem;
